const LAST_COMPANY_COOKIE = "last-company";

const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;

export function getLastCompanyId() {
  const cookie = document.cookie
    .split("; ")
    .find((entry) => entry.startsWith(`${LAST_COMPANY_COOKIE}=`));
  return cookie ? decodeURIComponent(cookie.split("=").slice(1).join("=")) : null;
}

export function setLastCompanyCookie(companyId) {
  document.cookie = `${LAST_COMPANY_COOKIE}=${encodeURIComponent(companyId)}; ${cookieAttributes()}`;
}

function cookieAttributes() {
  const attributes = [`Path=/`, `Max-Age=${ONE_YEAR_SECONDS}`, "SameSite=Lax"];
  const domain = parentCookieDomain();
  if (domain) attributes.push(`Domain=${domain}`);
  if (window.location.protocol === "https:") attributes.push("Secure");
  return attributes.join("; ");
}

function parentCookieDomain(hostname = window.location.hostname) {
  if (hostname === "localhost" || hostname.includes(":") || /^[\d.]+$/.test(hostname)) {
    return null;
  }

  const parts = hostname.split(".");
  return parts.length > 2 ? parts.slice(1).join(".") : hostname;
}
